import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import { Url } from '@wix/da-url';
import { BiEventType, ReferralType } from '../../../biLogger/constants';
export var MatureAnonymousBlockedFullView = function (props) {
    var t = useTranslation().t;
    return (React.createElement(HiddenLayout, __assign({ iconType: "hidden", title: t([
            "deviationview.blocked.mature.anon",
            'deviationview.blocked.default',
        ]), text: t("deviationview.blocked.mature.anon.text", { defaultValue: null }), buttons: [
            {
                label: t("deviationview.blocked.mature.anon.signIn"),
                // Keeping joinpoint=mature since it was specifically requested in the ticket
                // Seems like BI is going to use this query param to track the requests?
                href: Url.joinLink() + "?joinpoint=mature",
                biData: {
                    evid: BiEventType.REDIRECT_TO_LOGIN,
                    referral_info: ReferralType.MATURE,
                },
            },
        ] }, props)));
};
export default MatureAnonymousBlockedFullView;
//# sourceMappingURL=MatureAnonymousBlocked.js.map